module.exports = __webpack_public_path__ + "img/pump-east.4666de87.png";